/* So.lab · structure Huel · thème V4MGL (shl.js) */
(function () {
  'use strict';
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var evPromise = null;
  function themeEvents() {
    if (!evPromise) evPromise = import('@theme/events').catch(function () { return null; });
    return evPromise;
  }
  function money(cents, cur) {
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function setCount(n) { qa('[data-shl-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function drawer() { return q('cart-drawer'); }

  function initCarousel(root) {
    if (root.dataset.shlReady) return; root.dataset.shlReady = '1';
    var track = q('[data-shl-track]', root); if (!track) return;
    var prev = q('[data-shl-prev]', root), next = q('[data-shl-next]', root), dots = q('[data-shl-dots]', root);
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-static', max < 8);
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft > max - 8;
      if (dots) {
        var n = Math.max(1, Math.ceil(track.scrollWidth / Math.max(1, track.clientWidth)));
        if (dots.children.length !== n) { dots.innerHTML = ''; for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span')); }
        var a = max > 0 ? Math.round(track.scrollLeft / max * (n - 1)) : 0;
        qa('span', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === a); });
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    var raf = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initHeader(root) {
    if (root.dataset.shlReady) return; root.dataset.shlReady = '1';
    var menu = q('[data-shl-drawer]', root), burger = q('[data-shl-burger]', root), sub = null;
    function closeAll() { qa('.shl-hd__li.is-open', root).forEach(function (li) { li.classList.remove('is-open'); var b = q('[data-shl-dd]', li); if (b) b.setAttribute('aria-expanded', 'false'); }); }
    function closeSub(instant) {
      if (!sub) return false;
      var el = sub, opener = q('[data-shl-mm-open="' + el.id + '"]', menu); sub = null;
      el.classList.remove('is-open');
      if (instant) el.hidden = true;
      else { setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 340); if (opener) opener.focus(); }
      return true;
    }
    function openSub(id) {
      var el = document.getElementById(id); if (!el) return;
      closeSub(true); el.hidden = false; el.scrollTop = 0; void el.offsetWidth; el.classList.add('is-open'); sub = el;
      var back = q('[data-shl-mm-back]', el); if (back) back.focus({ preventScroll: true });
    }
    function selectTab(tab, focus) {
      qa('[data-shl-mm-tab]', menu).forEach(function (t) {
        var on = t === tab, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    function openMenu() { if (!menu) return; closeSub(true); menu.classList.remove('is-scrolled'); menu.hidden = false; menu.scrollTop = 0; document.documentElement.classList.add('shl-lock'); if (burger) burger.setAttribute('aria-expanded', 'true'); var c = q('[data-shl-close]', menu); if (c) c.focus({ preventScroll: true }); }
    function closeMenu(keepFocus) { if (!menu || menu.hidden) return; closeSub(true); menu.hidden = true; document.documentElement.classList.remove('shl-lock'); if (burger) { burger.setAttribute('aria-expanded', 'false'); if (!keepFocus) burger.focus(); } }
    qa('[data-shl-dd]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var li = btn.closest('.shl-hd__li'); var willOpen = !li.classList.contains('is-open');
        closeAll(); li.classList.toggle('is-open', willOpen); btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); if (!closeSub()) closeMenu(); } });
    if (burger) burger.addEventListener('click', openMenu);
    qa('[data-shl-close]', root).forEach(function (b) { b.addEventListener('click', function () { closeMenu(); }); });
    qa('[data-shl-cart]', root).forEach(function (a) {
      a.addEventListener('click', function (e) { var d = drawer(); if (d && typeof d.open === 'function') { e.preventDefault(); closeMenu(); d.open(); } });
    });
    if (!menu) return;
    var tabs = qa('[data-shl-mm-tab]', menu);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectTab(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); selectTab(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
    qa('[data-shl-mm-open]', menu).forEach(function (b) { b.addEventListener('click', function () { openSub(b.getAttribute('data-shl-mm-open')); }); });
    qa('[data-shl-mm-back]', menu).forEach(function (b) { b.addEventListener('click', function () { closeSub(); }); });
    qa('[data-shl-mm-country]', menu).forEach(function (s) { s.addEventListener('change', function () { if (s.form) s.form.submit(); }); });
    var head = q('[data-shl-mm-head]', menu);
    if (head && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { if (!menu.hidden) menu.classList.toggle('is-scrolled', !entries[0].isIntersecting); }, { root: menu }).observe(head);
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) closeMenu(true); });
    document.addEventListener('shopify:block:select', function (e) {
      if (!menu.contains(e.target)) return;
      var panel = e.target.closest('[role="tabpanel"]'), tab = panel && q('[aria-controls="' + panel.id + '"]', menu);
      if (tab) selectTab(tab);
      if (menu.hidden) openMenu();
      e.target.scrollIntoView({ block: 'center' });
    });
  }

  function initBuy(root) {
    if (root.dataset.shlReady) return; root.dataset.shlReady = '1';
    var scope = root.closest('[data-shl-pdp]') || document;
    var rows = qa('[data-shl-row]', root);
    var cur = root.dataset.currency || 'EUR';
    var threshold = parseInt(root.dataset.threshold || '0', 10) || 0;
    var cartTotal = parseInt(root.dataset.cartTotal || '0', 10) || 0;
    var synced = false;
    var totalEl = q('[data-shl-total]', root), shipEl = q('[data-shl-ship]', root), errEl = q('[data-shl-error]', root);
    var btns = qa('[data-shl-add]', scope), stickyTotal = q('[data-shl-sticky-total]', scope);
    function qty(r) { return parseInt(r.dataset.qty || '0', 10) || 0; }
    function state() { var s = { items: [], sum: 0, n: 0 }; rows.forEach(function (r) { var k = qty(r); if (k > 0) { s.items.push({ id: parseInt(r.dataset.variant, 10), quantity: k }); s.sum += k * parseInt(r.dataset.price, 10); s.n += k; } }); return s; }
    function render() {
      rows.forEach(function (r) { var k = qty(r); r.classList.toggle('has-qty', k > 0); var el = q('[data-shl-q]', r); if (el) el.textContent = k; });
      var s = state();
      if (totalEl) totalEl.textContent = money(s.sum, cur);
      if (stickyTotal) stickyTotal.textContent = money(s.sum, cur);
      btns.forEach(function (b) {
        var l = q('[data-shl-label]', b) || b; var sticky = b.hasAttribute('data-shl-sticky-btn');
        b.disabled = !sticky && s.n === 0;
        l.textContent = s.n ? (b.dataset.labelAdd + (sticky ? '' : ' · ' + money(s.sum, cur))) : b.dataset.labelChoose;
      });
      if (shipEl && threshold > 0) {
        var left = threshold - cartTotal - (synced ? 0 : s.sum);
        shipEl.textContent = left > 0 ? 'Plus que ' + money(left, cur) + ' pour la livraison offerte' : 'Livraison offerte sur cette commande';
      }
    }
    rows.forEach(function (r) {
      var plus = q('[data-shl-plus]', r), minus = q('[data-shl-minus]', r);
      if (plus) plus.addEventListener('click', function () { r.dataset.qty = Math.min(10, qty(r) + 1); synced = false; render(); });
      if (minus) minus.addEventListener('click', function () { r.dataset.qty = Math.max(0, qty(r) - 1); synced = false; render(); });
    });
    function add() {
      var s = state();
      if (!s.n) { var list = q('.shl-rows', root); if (list) list.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (errEl) errEl.hidden = true;
      btns.forEach(function (b) { b.classList.add('is-loading'); });
      var d = drawer(), sid = d && d.dataset.sectionId;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var body = { items: s.items };
      if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
      var added = null;
      fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) { return res.json().then(function (data) { if (!res.ok || data.status) throw new Error(data.description || data.message || 'Impossible d’ajouter ce produit au panier.'); return data; }); })
        .then(function (data) { added = data; return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          setCount(cart.item_count); cartTotal = cart.total_price; synced = true; render();
          return themeEvents().then(function (ev) {
            if (ev && ev.CartUpdatedEvent && d && added && added.sections) {
              document.dispatchEvent(new ev.CartUpdatedEvent({}, { itemCount: cart.item_count, source: 'shl-buy', sections: added.sections }));
              if (typeof d.open === 'function') d.open();
            } else {
              window.location.href = base + 'cart';
            }
          });
        })
        .catch(function (e) { if (errEl) { errEl.textContent = e.message; errEl.hidden = false; } })
        .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
    }
    btns.forEach(function (b) { b.addEventListener('click', add); });
    var sticky = q('[data-shl-sticky]', scope), main = q('[data-shl-add]', root);
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { var e = entries[0]; sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(main);
    }
    render();
  }

  function initPrefs(scope) {
    qa('[data-shl-prefs]', scope).forEach(function (a) {
      if (a.dataset.shlReady) return; a.dataset.shlReady = '1';
      a.addEventListener('click', function (e) { var pd = window.Pandectes && window.Pandectes.fn; if (pd && typeof pd.openPreferences === 'function') { e.preventDefault(); pd.openPreferences(); return; } var cp = window.Shopify && window.Shopify.customerPrivacy; if (cp && typeof cp.showPreferences === 'function') { e.preventDefault(); cp.showPreferences(); } });
    });
  }

  themeEvents().then(function (ev) {
    if (!ev || !ev.ThemeEvents) return;
    document.addEventListener(ev.ThemeEvents.cartUpdated, function (e) {
      var data = e.detail && e.detail.data; if (!data) return;
      if (typeof data.itemCount === 'number') setCount(data.itemCount);
      if (['shl-buy', 'cart-drawer-item', 'cart-reservation-timer'].indexOf(data.source || '') === -1) { var d = drawer(); if (d && typeof d.open === 'function') d.open(); }
    });
  });

  function init(scope) {
    scope = scope || document;
    qa('[data-shl-carousel]', scope).forEach(initCarousel);
    qa('[data-shl-header]', scope).forEach(initHeader);
    qa('[data-shl-buy]', scope).forEach(initBuy);
    initPrefs(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Widgets flottants des applis (chat, cookies…) : jamais au-dessus du panier, du menu mobile ni des barres d'achat fixes,
   et icône de secours quand l'image du bouton cookies ne charge pas */
(function () {
  'use strict';
  var OWN = 'cart-drawer,.shopify-section,.shl-fall,.sop-sticky,.shl-sticky,main,script,style,link,noscript,template,dialog,toast-notification,[class*="toast"]';
  var MARK = 'data-shl-float-hidden';
  var CONSENT = /cookie|consent|gdpr|rgpd|pandect|privacy|confidentialit|pr[ée]f[ée]rence/i;
  var COOKIE = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#2A1A45" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a9 9 0 1 0 9 9 3.2 3.2 0 0 1-3.6-3.1A3.2 3.2 0 0 1 14 5.6 3.1 3.1 0 0 1 12 3z" fill="#EDEAF2"/><circle cx="8.6" cy="10.2" r="1.1" fill="#2A1A45" stroke="none"/><circle cx="11.2" cy="15.6" r="1.1" fill="#2A1A45" stroke="none"/><circle cx="15.8" cy="13.9" r="1.1" fill="#2A1A45" stroke="none"/><circle cx="7.6" cy="15" r=".7" fill="#2A1A45" stroke="none"/></svg>');
  var hidden = [], lastMode = '', raf = 0;

  function children(el) {
    var list = Array.prototype.slice.call(el.children);
    return el.shadowRoot ? Array.prototype.slice.call(el.shadowRoot.children).concat(list) : list;
  }
  function collectFixed(el, depth, out) {
    var cs = getComputedStyle(el);
    if (cs.display === 'none') return;
    if (cs.position === 'fixed') { out.push(el); return; }
    if (depth > 3) return;
    children(el).forEach(function (c) { collectFixed(c, depth + 1, out); });
  }
  function widgets() {
    var list = [];
    Array.prototype.forEach.call(document.body.children, function (top) {
      if (top.matches(OWN) || top.hasAttribute(MARK)) return;
      var found = [];
      collectFixed(top, 0, found);
      if (!found.length && top.tagName.indexOf('-') > 0 && getComputedStyle(top).display !== 'none') found.push(top);
      found.forEach(function (el) { list.push({ top: top, el: el }); });
    });
    return list;
  }
  function hide(el) {
    if (el.hasAttribute(MARK)) return;
    el.setAttribute(MARK, el.style.getPropertyValue('display') + '|' + el.style.getPropertyPriority('display'));
    el.style.setProperty('display', 'none', 'important');
    hidden.push(el);
  }
  function restore() {
    hidden.forEach(function (el) {
      var v = (el.getAttribute(MARK) || '|').split('|');
      el.removeAttribute(MARK);
      if (v[0]) el.style.setProperty('display', v[0], v[1]); else el.style.removeProperty('display');
    });
    hidden = [];
  }
  function mode() {
    if (document.querySelector('cart-drawer.is-open') || document.documentElement.classList.contains('shl-lock')) return 'all';
    if (document.querySelector('.sop-sticky.is-visible,.shl-sticky.is-visible')) return 'bottom';
    return '';
  }
  function sync() {
    raf = 0;
    var m = mode();
    if (m !== lastMode && lastMode === 'all') restore();
    if (!m) { restore(); lastMode = ''; return; }
    lastMode = m;
    var vh = window.innerHeight, vw = document.documentElement.clientWidth;
    widgets().forEach(function (w) {
      if (m === 'all') { hide(w.top); return; }
      var r = w.el.getBoundingClientRect();
      var name = w.top.id + ' ' + w.top.tagName + ' ' + (typeof w.top.className === 'string' ? w.top.className : '');
      if (r.width > 0 && r.width < vw * 0.6 && r.height < 240 && r.bottom > vh - 170) hide(w.el);
      else if (w.el === w.top && /chat|inbox/i.test(name)) hide(w.top);
    });
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(sync); }

  function inFixed(el) {
    for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement || (n.getRootNode && n.getRootNode().host)) {
      if (getComputedStyle(n).position === 'fixed') return n;
    }
    return null;
  }
  function repair(img) {
    if (!img || img.tagName !== 'IMG' || img.hasAttribute('data-shl-repaired') || !img.getAttribute('src')) return;
    if (img.closest(OWN)) return;
    var box = inFixed(img);
    if (!box) return;
    var top = img;
    while (top.parentElement && top.parentElement !== document.body) top = top.parentElement;
    var host = img.closest('[aria-label],[title]');
    var label = [img.alt, img.title, img.getAttribute('src'), host ? (host.getAttribute('aria-label') || host.title) : '', top.id, typeof top.className === 'string' ? top.className : ''].join(' ');
    var r = box.getBoundingClientRect();
    var corner = r.width < 120 && r.height < 120 && r.left < 120 && r.bottom > window.innerHeight - 200;
    if (!CONSENT.test(label) && !corner) return;
    img.setAttribute('data-shl-repaired', '');
    img.removeAttribute('srcset');
    img.style.objectFit = 'contain';
    img.src = COOKIE;
  }
  function scan() {
    Array.prototype.forEach.call(document.images, function (img) { if (img.complete && img.naturalWidth === 0) repair(img); });
  }

  function watch(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('cart-drawer,.sop-sticky,.shl-sticky'), function (el) {
      if (el.dataset.shlFloatWatch) return; el.dataset.shlFloatWatch = '1';
      classObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }
  var classObserver = new MutationObserver(schedule);
  function start() {
    classObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    watch(document);
    new MutationObserver(function () { if (mode()) schedule(); }).observe(document.body, { childList: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', function (e) { watch(e.target); schedule(); });
    schedule();
    scan();
    window.addEventListener('load', scan);
    setTimeout(scan, 3000);
    setTimeout(scan, 8000);
  }
  document.addEventListener('error', function (e) { repair(e.target); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
